module.exports = __webpack_public_path__ + "static/media/left-arrow.a6471d64.svg";